<h2 mat-dialog-title>Info</h2>
<mat-dialog-content>
    <div class="access-info-text mb-4">
        <p>Linking your Uber account to Octopus:</p>
        <ul>
            <li>Makes your application quicker</li>
            <li>Prioritizes your free tablet shipment</li>
            <li>
                Speeds up logging into your Driver Dashboard after you start
                driving
            </li>
        </ul>
        <p>
            Your Uber trip and profile information will not be shared outside of
            Octopus.
        </p>
        <p class="mt-3">
            Please click <strong>ALLOW</strong> on the next screen to proceed
            and expedite your application.
        </p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="btn btn-pink close-btn" mat-dialog-close id="rideshare-dialog-go-back-button">
        Go Back
    </button>
    <button mat-button class="btn btn-pink btn-pink-filled" id="rideshare-dialog-proceed-button">Ok, proceed</button>
</mat-dialog-actions>
